import { FormattedMessage } from 'react-intl';

import { AppointmentActionKey } from '@/features/maintenance-data/appointmentMessages';
import { MaintenanceDataActions } from '@/features/maintenance-data/components/MaintenanceDataActions';
import { RowSelectionDerived } from '@/features/maintenance-data/hooks/useRowSelection';

export interface MaintenanceDataLeftToolbarProps {
    selection: RowSelectionDerived;
    availableActions?: ReadonlySet<AppointmentActionKey>;
    isUpdating?: boolean;
    onMarkSolved?: () => void;
    onRevertSolved?: () => void;
    onSchedule?: () => void;
    onEditAppointment?: () => void;
    onCancelAppointment?: () => void;
}

/**
 * Left toolbar for the maintenance-data table: hosts the "New custom component" button and the
 * state-driven Actions dropdown.
 */
export const MaintenanceDataLeftToolbar = ({
    selection,
    availableActions,
    isUpdating,
    onMarkSolved,
    onRevertSolved,
    onSchedule,
    onEditAppointment,
    onCancelAppointment,
}: MaintenanceDataLeftToolbarProps) => {
    return (
        <div className="display-flex gap-10 align-items-center">
            <button type="button" className="btn btn-default" disabled={selection.selectedCount === 0}>
                <span className="rioglyph rioglyph-plus margin-right-5" aria-hidden="true" />
                <FormattedMessage id="intl-msg:vehicle-diagnostics.maintenance.table.actions.newCustomComponent" />
            </button>
            <MaintenanceDataActions
                selection={selection}
                availableActions={availableActions}
                isUpdating={isUpdating}
                onMarkSolved={onMarkSolved}
                onRevertSolved={onRevertSolved}
                onSchedule={onSchedule}
                onEditAppointment={onEditAppointment}
                onCancelAppointment={onCancelAppointment}
            />
        </div>
    );
};
